import gql from 'graphql-tag';

export default gql`
    mutation CountLoadsByJobSummeryIdsAndStatuses($input: CountLoadsInput) {
        countLoadsByJobSummeryIdsAndStatuses(input: $input) {
            count
        }
    }
`;
